const trans = {
  Home: "الرئيسية",
  "Quick Access": "اختصارات",
  "News Center": "الأخبار",
  "Write a comment": "اكتب تعليق",
  "Your comment": "تعليقك",
  "Posted your comment successfuly": "تم كتابة التعليق بنجاح",
  "You commented:": "تعليقك:",
  "Are you sure you want to delete this comment?":
    "هل انت متأكد من حذف هذا التعليق؟",
  "Posted on:": "نشر: ",
  Post: "انشر",
  "pending orders": "طلبات جديدة",
  "Hello,": "مرحبا،",
  "Last 7 days": "آخر 7 أيام",
  Yesterday: "الامس",
  "Last 30 days": "آخر 30 يوم",
  Today: "اليوم",
  "Daily Sales": "المبيعات اليومية",
  "# Orders": "عدد الطلبات",
  "News & Updates": "الأخبار والتحديثات",
  "All Branches": "جميع الأفرع",
  Returning: "عملاء متكررين",
  "Avg rating": "معدل التقييمات",
  Feedbacks: "آراء",
  "Repeat Customer": "عملاء متكررين",
  "New Customer": "عملاء جدد",
  Checks: "التحققات",
  "You have": "لديك",
  "major issues": "مشاكل طارئة",
  warnings: "تحذيرات",
  "Add a product": "اضف منتج",
  "Fill in your branch details": "اضف تفاصيل فرعك",
  "Add a payment method": "اضف طريقة دفع",
  "Add a delivery provider": "اضف موفر توصيل",
  "*** of *** items complete": "*** من *** مكتمل",
  "Quick Start Guide": "دليل البدء السريع",
  "Set your working hours": "حدد ساعات عملك",
  "Your phone/email has not been verified. Please complete the verification process":
    "لم يتم توثيق الايميل/رقم الهاتف. الرجاء اكمال عملية التوثيق",
  "before 3rd of Feb 2025": "قبل 3 من فبراير 2025",
  "to avoid service interruptions. Failure to do so will lock your account.":
    "لتجنب انقطاع الخدمة. في حال عدم التوثيق، سيتم منع استخدام لوحة التحكم",
  "Verify Now": "توثيق الآن",
  "Account Verification Required": "الزام توثيق الحساب",
  "Verify your account before": "الرجاء توثيق بيانات التوصل قبل",
  "3rd of Feb 2025": "3 من فبراير 2025",
  "You must verify your email and phone in order to continue using the dashboard.":
    "يتوجب عليك توثيق حسابك لمتابعة الخدمة واستخدام شاشة التحكم بدون انقطاع.",
  "Action Required": "الرجاء الانتباه",
  "To avoid any interruptions, please verify your email and phone number":
    "لتجنب انقطاع الخدمة، الرجاء توثيق الايميل ورقم الهاتف",
  "Verify your": "الرجاء توثيق",
  phone: "رقم الهاتف",
  and: "و",
  before: "قبل",
  "to continue using your account": "لمتابعة استخدام حسابك",
  "You can't access your dashboard after this date":
    "لن تتمكن من دخول شاشة التحكم بعد هذا التاريخ",
  "How to verify?": "كيف اقوم بالتوثيق؟",
};

export default trans;
